import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse } from 'core/types';
import { getQueryString, objectKeysCamelToSnakeCase } from 'core/utils';

export const getPartPricingMultiplier = async (
  criteria,
  signal?: AbortSignal
): Promise<GetOneResponse<any>> => {
  const { data } = await partfinitiClient.get(
    `/pricing/multiplier/get-part-pricing-multiplier?${getQueryString(
      objectKeysCamelToSnakeCase(criteria)
    )}`,
    signal
  );

  return mapRecordFromServer(data.pricing_multiplier);
};
